<template>
	<page>
		<module>
			<view-list :work-type="workType" ref="view" selector :batch-edit="auth('b_equipment_point_edit')" :view-config="auth('b_equipment_point_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="点位编码">
							<c-input name="point_code"></c-input>
						</m-search-item>
						<m-search-item label="点位ID">
							<c-input name="device_point_id"></c-input>
						</m-search-item>
						<m-search-item label="所属机台">
							<c-select name="equipment_id" async @search="searchEquipment" :value-data="selectedEquipment"></c-select>
						</m-search-item>
						<m-search-item label="状态">
							<c-select name="state" multiple :options="disableEnableDic"></c-select>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button color="main" v-if="auth('b_equipment_point_edit')" v-lock="lock('b_equipment_point_edit')" prepend-icon="tf-add" @click="editPoint()">创建点位</c-button>
					<c-button v-if="auth('b_equipment_point_export')" v-lock="lock('b_equipment_point_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_equipment_point_export')" v-lock="lock('b_equipment_point_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
				</template>

				<template #batchOperate="{data}">
					<c-button v-if="auth('b_equipment_point_export')" v-lock="lock('b_equipment_point_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_equipment_point_print')" v-lock="lock('b_equipment_point_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">标签打印</c-button>
					<c-button v-if="auth('b_equipment_point_edit')" v-lock="lock('b_equipment_point_edit')" prepend-icon="tf-trash" color="red" :hollow="true" @click="batchRemovePoint">删除</c-button>
				</template>

				<template #state="{data}">
					<c-switch v-if="auth('b_equipment_point_edit')" v-model="data.state" :state-value="[1, 2]" :state-text="['启用','禁用']" @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
					<c-state v-else dict="disableEnableDic" :value="data.state"></c-state>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="200"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_equipment_point_edit')" v-lock="lock('b_equipment_point_edit')" icon="tf-edit" @click="editPoint(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_equipment_point_print')" v-lock="lock('b_equipment_point_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">标签打印</c-table-button>
						<c-table-button v-if="auth('b_equipment_point_edit')" v-lock="lock('b_equipment_point_edit')" icon="tf-trash" @click="removePoint(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</view-list>
			<!--新增/编辑点位弹窗-->
			<equipment-point-edit ref="equipmentPointEdit" :equipment-id="0" @resolve="$refs.view.update()"></equipment-point-edit>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import equipmentPointEdit from "@/pages/basic/equipment_point_edit.vue";

	export default {
		components: {equipmentPointEdit},
		computed: {
			...mapState(['disableEnableDic'])
		},
		data() {
			return {
				workType: 71,
				selectedEquipment: []
			}
		},
		methods: {
			searchEquipment(keyword, resolve){
				this.request({
					url: '/system/options',
					data: {
						options_code: 'EQUIPMENT',
						keyword: keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			editPoint(data) {
				this.$refs.equipmentPointEdit.open(data);
			},

			stateHandle(state, next, data) {
				this.request({
					url: '/equipment/point/edit/state',
					data: {
						id: data.id,
						state: state ? 2 : 1
					},
					success: () => {
						next();
					}
				})
			},

			removePoint(data) {
				this.$confirm({
					message:'确认删除点位【'+(data.point_code != null ? data.point_code : '无编码')+'】？删除后不可恢复',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/equipment/point/remove',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',
									type: 'success'
								});
								this.$refs.view.update();
							}
						});
					},
					cancel: () => {},
				});
			},

			batchRemovePoint(){
				var ids = [];
				this.$refs.view.$refs.list.getData('selected').forEach(item => {
					ids.push(item.id);
				});
				if(ids.length == 0){
					this.$message({message:'请选择要删除的点位', type:'warn'});
					return;
				}
				this.$confirm({
					message:'确认删除' + ids.length + '条点位记录吗？删除后不可恢复',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/equipment/point/remove/batch',
							data: {ids: ids},
							loading: true,
							success: data => {
								let Mtype = 'success';
								let message = '成功' + data.success_count + '条';
								if(data.fail_count > 0 && data.success_count > 0){
									Mtype = 'warn';
									message += '，失败'+data.fail_count+'条';
								}else if(data.fail_count > 0 && data.success_count == 0){
									Mtype = 'fail'
									message += '，失败'+data.fail_count+'条';
								}else{
									message = '成功删除' + data.success_count + '条记录';
								}
								this.$message({message: message, type: Mtype});
								this.$refs.view.update();
							}
						});
					},
					cancel: () => {},
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
